var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromo7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "promo",
    d: "M4.755,17.827v4.34l4.34-1.072,3.268,3.268,3.268-3.268,4.34,1.072v-4.34L24.363,16.7l-2.2-4.34,2.2-4.34L19.971,6.9V2.559l-4.34,1.072L12.363.363,9.095,3.631,4.755,2.559V6.9L.363,8.023l2.2,4.34L.363,16.7ZM4.5,11.393,3.529,9.4l1.736-.409a1.9,1.9,0,0,0,1.2-.74A2.211,2.211,0,0,0,6.9,6.9V5.367l1.634.459h.561a2.1,2.1,0,0,0,1.532-.664l1.736-1.736L14.1,5.163a2.1,2.1,0,0,0,1.532.664,1.5,1.5,0,0,0,.561-.1l1.634-.357V6.9a2.214,2.214,0,0,0,.434,1.353,1.9,1.9,0,0,0,1.2.741L21.2,9.4l-.97,1.992a1.971,1.971,0,0,0,0,1.94l.97,1.992-1.736.409a1.9,1.9,0,0,0-1.2.74,2.213,2.213,0,0,0-.434,1.352v1.532L16.193,18.9h-.561a2.1,2.1,0,0,0-1.532.664L12.363,21.3l-1.736-1.736A2.1,2.1,0,0,0,9.095,18.9a1.5,1.5,0,0,0-.561.1L6.9,19.359V17.827a2.214,2.214,0,0,0-.434-1.353,1.9,1.9,0,0,0-1.2-.74l-1.736-.409.97-1.992a1.971,1.971,0,0,0,0-1.94Zm6.792,4.7L16.4,10.933a1,1,0,0,0,0-1.532,1.049,1.049,0,0,0-1.532,0l-3.575,3.625L9.861,11.6a1.083,1.083,0,0,0-1.532,1.532Z",
    transform: "translate(-0.363 -0.363)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo7);
export default __webpack_public_path__ + "static/media/promo7.616947b405ce002bfb3cf68a8a1c7e24.svg";
export { ForwardRef as ReactComponent };